<ion-card [style]="'margin-top: ' + marginTop + 'rem'">
  <div class="header-spread" *ngIf="readyToShow">
    <p>{{ 'i18n.menuProfitPro.ingredientDetails.details' | translate }}</p>
    <ion-icon name="close-outline" (click)="closeDetails()"></ion-icon>
  </div>
  <div class="scroll-container" *ngIf="readyToShow">
    <app-ingredient-detail-header
      [product]="product"
      [isOnline]="isOnline"
      [pricingDisabled]="pricingDisabled"
      (ellipsisEvent)="ellipsisClick($event)"
      (productEvent)="onProductClick($event)"
    ></app-ingredient-detail-header>
    <app-ingredient-detail-sub-header
      [selectedTab]="selectedTab"
      [showInfoIcon]="showInfoIcon"
      class="sub-header"
    ></app-ingredient-detail-sub-header>
  </div>
  <div class="tab-content">
    <app-ingredient-units-of-measure
      [platform]="platform"
      [baseUnit]="currentCalculations?.displayBaseUnit"
      [baseQuantity]="currentCalculations?.baseQuantity"
      [conversionUnit]="currentCalculations?.displayConversionUnit"
      [conversionQuantity]="currentCalculations?.conversionQunatity"
      [solvedUnit]="currentCalculations?.displayTestUnit"
      [solvedQuantity]="currentCalculations?.testQuantity"
      [solvedCost]="currentCalculations?.testCost"
      [baseUnits]="currentCalculations?.allowedUnits"
      [conversionUnits]="currentCalculations?.possibleConversionUnits"
      [lockEdits]="lockEdits"
      (baseQuantityEvent)="updateBaseQunatity($event)"
      (conversionQuantityEvent)="updateConversionQuantity($event)"
      (baseUnitEvent)="updateBaseUnit($event)"
      (conversionUnitEvent)="updateConversionUnit($event)"
      (resultUnitEvent)="updateResultsUnit($event)"
      (saveChangesEvent)="saveUnitsOfMeasureCalculation()"
      (infoIconEvent)="clickInfoIcon($event)"
    >
    </app-ingredient-units-of-measure>
  </div>
</ion-card>
